import { FC, ReactElement } from 'react'

import { Icon } from '@/components'
import { ElementWithTooltip } from '@/compositions'
import { getDepartmentLabel } from '@/entities/Department/DepartmentHelpers'
import { Period } from '@/entities/Period/Period'
import { TrackShift } from '@/entities/Shift/Shift'
import { formatDate } from '@/helpers/legacyDate/parser'
import { trans } from '@/helpers/trans'
import { DateFormat } from '@/types'

import './CalendarShiftTrackTime.scss'

interface CalendarShiftTrackTimeProps {
    isOrphan?: boolean
    trackShift?: TrackShift
    shiftPeriod?: Period
    trackPeriod?: Period
    showEndTime?: boolean
    className?: string
}

export const CalendarShiftTrackTime: FC<CalendarShiftTrackTimeProps> = ({
    isOrphan,
    trackShift,
    shiftPeriod,
    showEndTime = false,
    className = '',
}): ReactElement => {
    const shiftStartTime = shiftPeriod ? formatDate(shiftPeriod.start, DateFormat.hoursMinutes) : undefined
    const shiftEndTime = shiftPeriod ? formatDate(shiftPeriod.end, DateFormat.hoursMinutes) : undefined

    return (
        <div className={`user-shift-track-time ${className}`}>
            {shiftPeriod ? (
                <div className="user-shift-track-time__time">
                    {shiftStartTime}
                    {showEndTime && ` - ${shiftEndTime}`}
                </div>
            ) : (
                <div className="user-shift-track-time__text">
                    {trans('common.unplanned')}

                    {(isOrphan && trackShift) && (
                        <ElementWithTooltip
                            tooltipIsActive
                            tooltipText={trans('compositions.userShiftTrackTime.orphanTrackTooltipLabel', { department: getDepartmentLabel(trackShift.department) })}
                        >
                            <Icon
                                name="info-circle"
                                className="user-shift-track-time__special-day-icon"
                            />
                        </ElementWithTooltip>
                    )}
                </div>
            )}
        </div>
    )
}
